<template>
   <div>
        <a @click="toggle(keyName, $event)" style="cursor:pointer"><slot></slot>
           <i v-if="direction === 'asc'" class="small fas fa-long-arrow-alt-down glyphicon glyphicon-arrow-down"></i>
           <span v-else>
              <i v-if="direction === 'desc'" class="small fas fa-long-arrow-alt-up glyphicon glyphicon-arrow-up"></i>
           </span>
        </a>
        <a v-if="direction.length > 0" class="btn-sm" style="cursor:pointer" @click="reset(keyName, $event)">
           <i class="fas fa-times glyphicon glyphicon-remove"></i>
        </a>
        <span v-else class="small fas fa-arrows-alt-v glyphicon glyphicon-resize-vertical"></span>
    </div>
</template>
<script>
export default {
  delimiters: ['${', '}'],
  props: {
    keyName: String
  },
  data: function () {
    return {
      direction: ''
    }
  },
  methods: {
    reset: function (itm, ev) {
      var self = this
      self.$emit('reset')
      self.$nextTick(function () {
        self.$parent.$forceUpdate()
      })
    },
    toggle: function (itm, ev) {
      var self = this
      self.direction = self.direction === 'asc' ? 'desc' : 'asc'
      self.$emit('sort', self)
      self.$nextTick(function () {
        self.$parent.$forceUpdate()
      })
    }
  }
}
</script>


// WEBPACK FOOTER //
// Sorter.vue?5f3251be